import React, {Component,} from 'react'

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import Firebase from 'firebase';
import { withRouter } from 'react-router-dom';
import './../../styles/css/screens/Leagues/leagues.css'

import _ from 'lodash'
import {
    CCAppEventLogger,
    CCUIUtils,
    CCLeaguesGroup,
    DataActionTypes as DataAT,
    Constants,
    CCUtils,
    CCActions,
    FirebaseUtils,
    SimpleMatchDetails
} from "./../../cc-imports";

class Leagues extends Component {

    static propTypes = {}

    static defaultProps = {}

    constructor(props) {
        super(props);
        this.state = {
            leagueGroups: [],
            matchId : undefined
        }
        this._fetchLeagues = this._fetchLeagues.bind(this);
        this._autoRefresh = this._autoRefresh.bind(this);
        this._manualRefresh = this._manualRefresh.bind(this);
        this._paginate = this._paginate.bind(this);
        this._updateGrouping = this._updateGrouping.bind(this);

        this._entryCountPressed = this._entryCountPressed.bind(this);
        this._leaguePressed = this._leaguePressed.bind(this);
        this._infoPressed = this._infoPressed.bind(this);
        this._getMatchId=this._getMatchId.bind(this);
    }

    componentDidMount() {
        this._fetchLeagues(this.props, DataAT.GET);
    }

    _getMatchId(props) {
        var matchId = undefined;
        const {matchesByStatus} = props;
        const matchIdFromUrl =  props.match ?  (props.match.params ? props.match.params.matchId : undefined): undefined;
        if(matchIdFromUrl){
            return matchIdFromUrl;
        }
        else {
            let liveMatches = matchesByStatus[Constants.matchStatus.STARTED];
            let upcomingMatches = matchesByStatus[Constants.matchStatus.NOT_STARTED];
            let completedMatches = matchesByStatus[Constants.matchStatus.COMPLETED];
            if(liveMatches && liveMatches.length>0){
                matchId = liveMatches[0];
            }
            else if(upcomingMatches && upcomingMatches.length>0) {
                matchId = upcomingMatches[0]
            }
            else if(completedMatches && completedMatches.length>0) {
                matchId = completedMatches[0];
            }
            else {
                matchId = undefined;
            }
        }
        return matchId;
    }

    _fetchLeagues(props, type) {
        const {actions, userId, leaguesPages} = this.props;
        //const matchId = props.navigation.state.params.matchId;
        const matchId= this._getMatchId(props);
        if(matchId){
            actions.getMatch(matchId, type);
            FirebaseUtils.getIdTokenWhenAuthChanged((idToken)=>{
                var page = leaguesPages[matchId] == undefined ? 0 : leaguesPages[matchId];
                var skip= (type==DataAT.AUTO_REFRESH || type==DataAT.MANUAL_REFRESH) ? 0 : page;
                var limit = (type==DataAT.AUTO_REFRESH || type==DataAT.MANUAL_REFRESH) ? page * 20 : 20;

                /*if( userId){
                    actions.getEntriesByUserId(idToken,userId,skip,limit,type);
                }*/

                actions.getLeaguesByMatchId(idToken,matchId,userId,skip,limit,type);
            });
        }

    }

    _autoRefresh() {
        this._fetchLeagues(this.props, DataAT.AUTO_REFRESH)
    }

    _manualRefresh() {
        this._fetchLeagues(this.props, DataAT.MANUAL_REFRESH)
    }

    _paginate() {
        const {leaguesReqStatus} = this.props;
        if(leaguesReqStatus!=Constants.reqStatus.FAI && leaguesReqStatus!=Constants.reqStatus.COM){
            this._fetchLeagues(this.props, DataAT.PAGINATE);
        }
    }

    _updateGrouping(props) {
        var matchId =  this._getMatchId(this.props);
        const {leaguesByMatch, leaguesById, matchesById}=props;

        var leagueIds = leaguesByMatch[matchId];
        var leaguesForMatch = [];
        const match = matchesById[matchId];


        //TODO : temp workaround
        if(match==undefined || matchId==undefined){
            return [];
        }

        _.forEach(leagueIds, (leagueId) => {
            const league = leaguesById[leagueId];
            if (match.status == Constants.matchStatus.COMPLETED) {
                leaguesForMatch.push(league);
            }
            else {
                if (league.status == Constants.leagueStatus.NOT_STARTED || league.status == Constants.leagueStatus.LIVE) {
                    leaguesForMatch.push(league);
                }
            }
        });


        var groupedLeagues = _.groupBy(leaguesForMatch, (league) => {
            return league.sponsor.key == null || league.sponsor.key == undefined ? 'none' : league.sponsor.key
        });

        var leagueGroups = []

        _.forIn(groupedLeagues, (value, key) => {
            const sponsor = props.sponsorsByKey[key];
            const sortedLeagues = _.orderBy(value, [(league)=>{
                return league.status==Constants.leagueStatus.NOT_STARTED ? 1 : 0
            }, (league) => {
                return new Date(league.createdDate)
            }], ['desc', 'asc']);
            leagueGroups.push({
                sponsor: sponsor,
                priority: (sponsor && sponsor.priority) ? sponsor.priority : 100,
                leagues: sortedLeagues,
                matchCompleted : match.status == Constants.matchStatus.COMPLETED
            });
        });

        leagueGroups = _.orderBy(leagueGroups, [(leagueGroup) => {
            return leagueGroup.priority
        }], ['asc']);
        //this.setState({leagueGroups});
        return leagueGroups;
    }

    _entryCountPressed(league) {
        CCAppEventLogger.logAppEvent("EntryCountPressed", {
            league_type: league.type,
            league_category: league.category,
            match_key: league.match.key,
            league_status: league.status,
            loggedIn: CCUtils.isLoggedIn(this.props.user)
        });
        this.props.actions.openSingleLeagueModal(league);
    }

    _leaguePressed(league) {
        const {actions}=this.props;
        CCAppEventLogger.logAppEvent("OpenLeagueClicked", {
            league_type: league.type,
            league_category: league.category,
            match_key: league.match.key,
            league_status: league.status,
            loggedIn: CCUtils.isLoggedIn(this.props.user)
        });
        if (league.status == Constants.leagueStatus.NOT_STARTED) {
            switch (league.category) {
                case Constants.leagueCategory.PREDICTION:
                case Constants.leagueCategory.LIVE_PREDICTION:
                case Constants.leagueCategory.QUICK_PREDICTION:
                    actions.openPredictionEntryCreationModal(league);
                    break;
                case Constants.leagueCategory.DREAMTEAM:
                    actions.openDreamTeamEntryCreationModal(league);
                    break;
            }
        }
        else {
            actions.openSingleLeagueModal(league);
        }


    }

    _infoPressed(sponsor) {
        this.props.actions.openSponsorDetailsModal(sponsor);
    }

    componentWillReceiveProps(nextProps) {
        //var matchId = this._getMatchId();
        if (CCUtils.userUpdated(this.props.user, nextProps.user)) {
            this._fetchLeagues(nextProps, DataAT.GET, 0);
        }
        if(Object.keys(nextProps.matchesById).length!=Object.keys(this.props.matchesById).length){
           this._fetchLeagues(nextProps,DataAT.GET,0);
        }

        if(this.props.navMatchId!=nextProps.navMatchId){
            this._fetchLeagues(nextProps,DataAT.GET,0);
        }
        /*if (nextProps.leaguesRandom != this.props.leaguesRandom) {
            this._updateGrouping(nextProps);
        }*/
    }

    render() {
        const {leaguesById, leaguesReqStatus, matchesById, actions, leaguesByMatch, leaguesType, user} = this.props;
        let matchId = this._getMatchId(this.props);
        let match = matchesById[matchId];
        let leagues = leaguesByMatch[matchId]?leaguesByMatch[matchId]:[];
        let leagueGroups = this._updateGrouping(this.props);
        return (
            <div>
                {/*<div className={'flex-container'} style={{flex:1, justifyContent:'center', height:'45px'}}>

                </div>*/}
                <div className={'flex-container leagues_container'}>
                    <div className={'leagues_container_2'}>
                        <div className={'leagues-list'}>
                            {
                                match!=undefined &&
                                <SimpleMatchDetails showPlay={false} ccMatch={match}></SimpleMatchDetails>
                            }
                            <div className={'leagues_scroll flex-container'}>
                                {
                                    (matchId && leagues.length==0) ?
                                        <div></div>
                                        :
                                        <div>
                                            {
                                                leagueGroups.map((leagueGroup)=>{
                                                    return(<CCLeaguesGroup currUser={user}
                                                                           entryCountPressed={this._entryCountPressed}
                                                                           leaguePressed={this._leaguePressed}
                                                                           infoPressed={this._infoPressed}
                                                                           sponsorBannerPressed={this._infoPressed}
                                                                           leagueGroup={leagueGroup}
                                                                           key={leagueGroup.sponsor}></CCLeaguesGroup>)
                                                })
                                            }
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
        storedDetails: state.storedDetails,
        fireBaseUser: state.fireBaseUser,

        user: state.user.user,
        userId: state.user.user.id ? state.user.user.id : Constants.anonymousUser,

        matchesById: state.matches.byId,
        matchesByStatus: state.matches.byStatus,
        matchesReqStatus: state.matches.reqStatus,
        matchesRandom: state.matches.random,

        leagues : state.leagues,
        leaguesById: state.leagues.byId,
        leaguesByMatch : state.leagues.byMatch,
        leaguesReqStatus : state.leagues.reqStatus,
        leaguesPages : state.leagues.pages,
        leaguesType : state.leagues.type,
        leaguesRandom : state.leagues.random,

        navMatchId : state.navigation.matchId,

        sponsorsByKey: state.sponsors.byKey
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(withRouter(Leagues));



// WEBPACK FOOTER //
// ./src/app/screens/Leagues/Leagues.js